export default {
    LOGIN: "[zina_flow][auth] LOGIN",
    LOGIN_SUCCESS: "[zina_flow][auth] LOGIN_SUCCESS",
    LOGIN_FAIL: "[zina_flow][auth] LOGIN_FAIL",
    NEW_TOKEN: "[zina_flow][auth] new token",
    REFRESH_TOKEN: "[zina_flow][auth] refresh token",
    EXPIRED_TOKEN: "[zina_flow][auth] expired token",
    LOGOUT: "[zina_flow][auth] LOGOUT"
};
